import { InputFieldType } from '@e2m-customer-portal/shared';
import { MachineTechnology } from '@e2m-customer-portal/shared';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  /** A date-time string at UTC, such as 2019-12-03T09:54:33Z, compliant with the date-time format. */
  DateTime: Date;
};

export type Account = {
  readonly __typename?: 'Account';
  readonly email: Scalars['String'];
  readonly id: Scalars['ID'];
  readonly marketLocations?: Maybe<ReadonlyArray<AssignedMarketLocation>>;
  readonly name: Scalars['String'];
  readonly permissions: ReadonlyArray<AssignedPermission>;
};

export type Address = {
  readonly __typename?: 'Address';
  readonly city?: Maybe<Scalars['String']>;
  /** Holds an ISO 3166 country code. */
  readonly country?: Maybe<Scalars['String']>;
  /** Holds the ISO 3166 official country name. */
  readonly countryName?: Maybe<Scalars['String']>;
  readonly houseNumber?: Maybe<Scalars['String']>;
  readonly organization?: Maybe<Scalars['String']>;
  readonly postCode?: Maybe<Scalars['String']>;
  readonly street?: Maybe<Scalars['String']>;
};

export type AddressInput = {
  readonly city?: InputMaybe<Scalars['String']>;
  /** Holds an ISO 3166 country code. */
  readonly country?: InputMaybe<Scalars['String']>;
  /** Holds the ISO 3166 official country name. */
  readonly countryName?: InputMaybe<Scalars['String']>;
  readonly houseNumber?: InputMaybe<Scalars['String']>;
  readonly organization?: InputMaybe<Scalars['String']>;
  readonly postCode?: InputMaybe<Scalars['String']>;
  readonly street?: InputMaybe<Scalars['String']>;
};

export type AnnualOverview = {
  readonly __typename?: 'AnnualOverview';
  readonly latestFeedDate?: Maybe<Scalars['DateTime']>;
  readonly marketLocationId: Scalars['ID'];
  readonly monthlyOverview: ReadonlyArray<MonthOverview>;
  readonly totalConsumptionMeasurementMean: NullableMeasure;
  readonly totalConsumptionMeasurementSum: NullableMeasure;
  readonly totalForecastedMean: NullableMeasure;
  readonly totalForecastedSum: NullableMeasure;
  readonly totalMeasuredFeedsAtLeast85PercentOfCapacity: Scalars['Int'];
  readonly totalMeasurementMean: NullableMeasure;
  readonly totalMeasurementSum: NullableMeasure;
};

export type AssignedMarketLocation = {
  readonly __typename?: 'AssignedMarketLocation';
  readonly externalName?: Maybe<Scalars['String']>;
  readonly id: Scalars['ID'];
  readonly name: Scalars['String'];
};

export type AssignedPermission = {
  readonly __typename?: 'AssignedPermission';
  readonly granted: Scalars['Boolean'];
  readonly id: Scalars['ID'];
  readonly permissionId: Scalars['ID'];
};

export type AssignedPermissionInput = {
  readonly granted: Scalars['Boolean'];
  readonly permissionId: Scalars['ID'];
};

export type BillingType = {
  readonly __typename?: 'BillingType';
  readonly isOpenBook: Scalars['Boolean'];
  readonly month: Month;
  readonly year: Scalars['Int'];
};

export type Datapoint = {
  readonly __typename?: 'Datapoint';
  readonly type: DatapointType;
  readonly value: Scalars['Float'];
};

export type DatapointCollection = {
  readonly __typename?: 'DatapointCollection';
  readonly entityType: EntityType;
  readonly resolution: Resolution;
  readonly timeSlices: ReadonlyArray<TimeSlice>;
  readonly type: DatapointCollectionType;
};

export enum DatapointCollectionType {
  DSO_MEASUREMENT = 'DSO_MEASUREMENT',
  FORECAST = 'FORECAST',
  VPP_MEASUREMENT = 'VPP_MEASUREMENT'
}

export enum DatapointType {
  AFRR_BAND_NEGATIVE = 'AFRR_BAND_NEGATIVE',
  AFRR_BAND_POSITIVE = 'AFRR_BAND_POSITIVE',
  AFRR_LOWER_LIMIT = 'AFRR_LOWER_LIMIT',
  AFRR_UPPER_LIMIT = 'AFRR_UPPER_LIMIT',
  AVAILABILITY = 'AVAILABILITY',
  DAY_AHEAD_COMMITTED_PRODUCTION = 'DAY_AHEAD_COMMITTED_PRODUCTION',
  DOWNTIME = 'DOWNTIME',
  FCR_BAND = 'FCR_BAND',
  FLEXPLUS_LOWER_LIMIT = 'FLEXPLUS_LOWER_LIMIT',
  FLEXPLUS_UPPER_LIMIT = 'FLEXPLUS_UPPER_LIMIT',
  MFRR_BAND_NEGATIVE = 'MFRR_BAND_NEGATIVE',
  MFRR_BAND_POSITIVE = 'MFRR_BAND_POSITIVE',
  MFRR_LOWER_LIMIT = 'MFRR_LOWER_LIMIT',
  MFRR_UPPER_LIMIT = 'MFRR_UPPER_LIMIT',
  POWER_FEED = 'POWER_FEED',
  POWER_PRODUCTION = 'POWER_PRODUCTION'
}

export type Deadline = {
  readonly __typename?: 'Deadline';
  readonly deadline?: Maybe<MarketingDeadline>;
  readonly type: InputFieldType;
};

export type DefaultForecast = {
  readonly __typename?: 'DefaultForecast';
  readonly auxiliaryConsumption: NullableMeasure;
  readonly forecasts: ReadonlyArray<DefaultForecastSlice>;
  readonly id: Scalars['ID'];
  readonly maximum: NullableMeasure;
  readonly minimum: NullableMeasure;
  readonly month: Month;
};

export type DefaultForecastInput = {
  readonly auxiliaryConsumption: MeasureInput;
  readonly forecasts: ReadonlyArray<ForecastInput>;
  readonly maximum: MeasureInput;
  readonly minimum: MeasureInput;
  readonly month: Month;
};

export type DefaultForecastSlice = {
  readonly __typename?: 'DefaultForecastSlice';
  readonly interval: Interval;
  readonly value: NullableMeasure;
};

export type DeleteAccountResponse = {
  readonly __typename?: 'DeleteAccountResponse';
  readonly deleted: Scalars['Boolean'];
};

export type Device = {
  readonly __typename?: 'Device';
  readonly deadlines: ReadonlyArray<Deadline>;
  readonly externalName?: Maybe<Scalars['String']>;
  readonly id: Scalars['ID'];
  readonly internalId: Scalars['ID'];
  readonly name: Scalars['String'];
  readonly products: ReadonlyArray<Product>;
  readonly tradingGroupId?: Maybe<Scalars['ID']>;
};

export type DeviceDatapoint = {
  readonly __typename?: 'DeviceDatapoint';
  readonly actualPower?: Maybe<Scalars['Float']>;
  readonly date: Scalars['DateTime'];
  readonly energyCapabilityNeg?: Maybe<Scalars['Float']>;
  readonly energyCapabilityPos?: Maybe<Scalars['Float']>;
};

export type DeviceInput = {
  readonly externalName?: InputMaybe<Scalars['String']>;
};

export type DeviceOptimizationStatus = {
  readonly __typename?: 'DeviceOptimizationStatus';
  readonly deviceId: Scalars['String'];
  readonly interval?: Maybe<Scalars['String']>;
  readonly isActive: Scalars['Boolean'];
  readonly nextRun?: Maybe<Scalars['DateTime']>;
};

export type DeviceTimeSeries = {
  readonly __typename?: 'DeviceTimeSeries';
  readonly datapoints: ReadonlyArray<DeviceDatapoint>;
  readonly deviceNumber: Scalars['ID'];
  readonly id: Scalars['ID'];
};

export enum EditableMarket {
  DAY_AHEAD = 'DAY_AHEAD',
  INTRADAY = 'INTRADAY'
}

export type Entity = {
  readonly __typename?: 'Entity';
  readonly datapoints: ReadonlyArray<Datapoint>;
  readonly number: Scalars['Int'];
};

export enum EntityType {
  DEVICE = 'DEVICE',
  MARKET_LOCATION = 'MARKET_LOCATION'
}

export type FeedIn = {
  readonly __typename?: 'FeedIn';
  readonly id: Scalars['ID'];
  readonly interval: Interval;
  readonly marketLocationId: Scalars['ID'];
  readonly values: ReadonlyArray<FeedInValue>;
};

export type FeedInMarketLocation = {
  readonly id: Scalars['ID'];
  readonly type?: InputMaybe<MarketLocationType>;
};

export type FeedInValue = {
  readonly __typename?: 'FeedInValue';
  readonly date: Scalars['DateTime'];
  readonly forecastedValue?: Maybe<Scalars['Float']>;
  readonly measuredValue?: Maybe<Scalars['Float']>;
  readonly msconsCode?: Maybe<Scalars['String']>;
};

export type FieldValue = {
  readonly __typename?: 'FieldValue';
  readonly type: InputFieldType;
  readonly value: NullableMeasure;
  readonly watt?: Maybe<Scalars['Int']>;
};

export type FieldValueInput = {
  readonly type: InputFieldType;
  readonly watt: Scalars['Int'];
};

export type Forecast = {
  readonly __typename?: 'Forecast';
  readonly deviceId: Scalars['ID'];
  readonly id: Scalars['ID'];
  readonly interval: Interval;
  readonly resolution: Resolution;
  readonly slices: ReadonlyArray<ForecastSlice>;
};

export type ForecastInput = {
  readonly interval: IntervalInput;
  readonly value: MeasureInput;
};

export type ForecastPageDeviceInput = {
  readonly deviceId: Scalars['ID'];
  readonly marketLocationId: Scalars['ID'];
};

export type ForecastPageFieldLimit = {
  readonly __typename?: 'ForecastPageFieldLimit';
  readonly isDisabled: Scalars['Boolean'];
  readonly lowerLimit: Limit;
  readonly negativeBand?: Maybe<NullableMeasure>;
  readonly positiveBand?: Maybe<NullableMeasure>;
  readonly type: InputFieldType;
  readonly upperLimit: Limit;
};

export type ForecastPageLimitsResponse = {
  readonly __typename?: 'ForecastPageLimitsResponse';
  readonly fields: ReadonlyArray<ForecastPageFieldLimit>;
  readonly installedPower: NullableMeasure;
};

export type ForecastProperty = {
  readonly __typename?: 'ForecastProperty';
  readonly editableMarkets: ReadonlyArray<EditableMarket>;
  readonly resolution: Resolution;
  readonly target: ForecastTarget;
  readonly validFrom: Scalars['String'];
  readonly validTo?: Maybe<Scalars['String']>;
};

export type ForecastSlice = {
  readonly __typename?: 'ForecastSlice';
  readonly date: Scalars['DateTime'];
  readonly fields: ReadonlyArray<FieldValue>;
  readonly hasDowntime: Scalars['Boolean'];
  readonly id: Scalars['ID'];
};

export type ForecastSliceInput = {
  readonly date: Scalars['DateTime'];
  readonly fields: ReadonlyArray<FieldValueInput>;
  readonly hasDowntime?: InputMaybe<Scalars['Boolean']>;
};

export enum ForecastTarget {
  ESDB = 'ESDB',
  VPP = 'VPP'
}

export { InputFieldType };

export type Interval = {
  readonly __typename?: 'Interval';
  readonly end: Scalars['DateTime'];
  readonly start: Scalars['DateTime'];
};

export type IntervalInput = {
  readonly end: Scalars['DateTime'];
  readonly start: Scalars['DateTime'];
};

export type Json = {
  readonly __typename?: 'Json';
  readonly json?: Maybe<Scalars['String']>;
};

export type Limit = {
  readonly __typename?: 'Limit';
  readonly limit: Measure;
  readonly limitSpecification: LimitSpecification;
};

export enum LimitSpecification {
  CONTRACTUAL = 'CONTRACTUAL',
  FCR = 'FCR',
  INSTALLED_CAPACITY = 'INSTALLED_CAPACITY',
  PAIRED_MAXIMUM = 'PAIRED_MAXIMUM',
  TECHNICAL = 'TECHNICAL',
  TEMPLATE = 'TEMPLATE'
}

export type Machine = {
  readonly __typename?: 'Machine';
  readonly address: Address;
  readonly devices: ReadonlyArray<Device>;
  readonly id: Scalars['ID'];
  readonly installedPower: NullableMeasure;
  readonly machineTechnology: MachineTechnology;
  readonly name: Scalars['String'];
};

export { MachineTechnology };

export type MarketLocation = {
  readonly __typename?: 'MarketLocation';
  readonly billingTypes: ReadonlyArray<BillingType>;
  readonly contractPartner: Scalars['String'];
  readonly distributionNetworkOperator?: Maybe<Scalars['String']>;
  readonly externalName: Scalars['String'];
  readonly forecastProperties?: Maybe<ReadonlyArray<ForecastProperty>>;
  readonly id: Scalars['ID'];
  readonly linkedMarketLocation?: Maybe<MarketLocation>;
  readonly machines: ReadonlyArray<Machine>;
  readonly machinesTotalOutput: NullableMeasure;
  readonly marketLocationId: Scalars['String'];
  readonly marketingEnd?: Maybe<Scalars['DateTime']>;
  readonly marketingStart?: Maybe<Scalars['DateTime']>;
  readonly measureLocationId: Scalars['String'];
  readonly name: Scalars['String'];
  readonly number: Scalars['String'];
  readonly permissions: MarketLocationPermissions;
  readonly productServices: ReadonlyArray<ProductService>;
  readonly products: ReadonlyArray<Product>;
  readonly technologies: ReadonlyArray<MachineTechnology>;
  readonly transmissionSystemOperator?: Maybe<Scalars['String']>;
  readonly type?: Maybe<MarketLocationType>;
};

/** A pageable list for {@link MarketLocation} elements that also contains meta information. */
export type MarketLocationConnection = {
  readonly __typename?: 'MarketLocationConnection';
  /** Contains the edges of the current page. */
  readonly edges: ReadonlyArray<MarketLocationEdge>;
  /** Contains meta information about the current page. */
  readonly pageInfo: PageInfo;
  /** The total number of elements across all pages. */
  readonly totalCount: Scalars['Int'];
};

export type MarketLocationDatapoint = {
  readonly __typename?: 'MarketLocationDatapoint';
  readonly timestamp: Scalars['DateTime'];
  readonly value?: Maybe<Scalars['Float']>;
};

/** Edge type for {@link MarketLocation} elements. */
export type MarketLocationEdge = {
  readonly __typename?: 'MarketLocationEdge';
  /** The cursor pointing to the element within the {@link node} field. */
  readonly cursor: Scalars['String'];
  /** The current element. */
  readonly node: MarketLocation;
};

export type MarketLocationPermissions = {
  readonly __typename?: 'MarketLocationPermissions';
  readonly editForecast: Scalars['Boolean'];
  readonly seeForecast: Scalars['Boolean'];
  readonly seeRevenue: Scalars['Boolean'];
};

export type MarketLocationTimeSeries = {
  readonly __typename?: 'MarketLocationTimeSeries';
  readonly datapoints: ReadonlyArray<MarketLocationDatapoint>;
  readonly id: Scalars['ID'];
  readonly marketLocationNumber: Scalars['ID'];
  readonly marketLocationTimeSeriesType: MarketLocationTimeSeriesType;
};

export enum MarketLocationTimeSeriesType {
  CALCULATED_PV_PRODUCTION = 'CALCULATED_PV_PRODUCTION'
}

export enum MarketLocationType {
  CONSUMER = 'CONSUMER',
  PRODUCER = 'PRODUCER',
  PROSUMER = 'PROSUMER'
}

export type MarketingDeadline = {
  readonly __typename?: 'MarketingDeadline';
  readonly daysBeforeDelivery: Scalars['Int'];
  readonly deadlineForEarliestForecast: Scalars['String'];
  readonly minutesBeforeIntradayDelivery?: Maybe<Scalars['Int']>;
};

export type Measure = {
  readonly __typename?: 'Measure';
  readonly unit: Scalars['String'];
  readonly value: Scalars['Float'];
};

export type MeasureInput = {
  readonly unit: Scalars['String'];
  readonly value: Scalars['Float'];
};

export enum Month {
  APRIL = 'APRIL',
  AUGUST = 'AUGUST',
  DECEMBER = 'DECEMBER',
  FEBRUARY = 'FEBRUARY',
  JANUARY = 'JANUARY',
  JULY = 'JULY',
  JUNE = 'JUNE',
  MARCH = 'MARCH',
  MAY = 'MAY',
  NOVEMBER = 'NOVEMBER',
  OCTOBER = 'OCTOBER',
  SEPTEMBER = 'SEPTEMBER'
}

export type MonthOverview = {
  readonly __typename?: 'MonthOverview';
  readonly meanConsumptionMeasurement: NullableMeasure;
  readonly meanForecasted: NullableMeasure;
  readonly meanMeasurement: NullableMeasure;
  readonly month: Month;
  readonly specificAdditionalRevenue: NullableMeasure;
  readonly totalConsumptionMeasurement: NullableMeasure;
  readonly totalForecasted: NullableMeasure;
  readonly totalMeasuredFeedsAtLeast85PercentOfCapacity: Scalars['Int'];
  readonly totalMeasurement: NullableMeasure;
};

export type MonthlyMarketValue = {
  readonly __typename?: 'MonthlyMarketValue';
  readonly isProvisional: Scalars['Boolean'];
  readonly max: Scalars['Float'];
  readonly mean: Scalars['Float'];
  readonly min: Scalars['Float'];
  readonly month: Month;
  readonly year: Scalars['Int'];
};

export type Mutation = {
  readonly __typename?: 'Mutation';
  readonly OptimizationGroupDataUpdate: Json;
  readonly OptimizationRunner: OptimizationRun;
  readonly changeDefaultForecast: ReadonlyArray<DefaultForecast>;
  readonly createAccount: Account;
  readonly deleteAccount: DeleteAccountResponse;
  readonly revokeDowntime: Scalars['Boolean'];
  readonly revokeLegacyDowntime: RevokeLegacyDowntimeResponse;
  readonly setDowntime: Scalars['Boolean'];
  readonly setLegacyDowntime: SetLegacyDowntimeResponse;
  readonly setSalesPartnerConfigured: SalesPartnerGroup;
  readonly setSalesPartnerPermission: AssignedPermission;
  readonly setSalesPartnersAsConfigured: ReadonlyArray<SalesPartner>;
  readonly updateAccount: Account;
  readonly updateAccountPermission: AssignedPermission;
  readonly updateDevice: Device;
  readonly updateForecast: ReadonlyArray<ForecastSlice>;
  readonly updateForecastWithTemplate: ReadonlyArray<ForecastSlice>;
  readonly updateSalesPartnerPermission: AssignedPermission;
};


export type MutationOptimizationGroupDataUpdateArgs = {
  siteId: Scalars['String'];
  updatedParameters?: InputMaybe<Scalars['String']>;
};


export type MutationOptimizationRunnerArgs = {
  siteId: Scalars['String'];
};


export type MutationChangeDefaultForecastArgs = {
  deviceId: Scalars['ID'];
  forecast: ReadonlyArray<DefaultForecastInput>;
};


export type MutationCreateAccountArgs = {
  email: Scalars['String'];
  marketLocationIds?: InputMaybe<ReadonlyArray<Scalars['ID']>>;
  name: Scalars['String'];
  permissions: ReadonlyArray<AssignedPermissionInput>;
};


export type MutationDeleteAccountArgs = {
  email: Scalars['String'];
};


export type MutationRevokeDowntimeArgs = {
  deviceNumber: Scalars['ID'];
  from: Scalars['DateTime'];
  to: Scalars['DateTime'];
};


export type MutationRevokeLegacyDowntimeArgs = {
  deviceNumber: Scalars['String'];
  from: Scalars['DateTime'];
  to: Scalars['DateTime'];
};


export type MutationSetDowntimeArgs = {
  deviceNumber: Scalars['ID'];
  from: Scalars['DateTime'];
  to: Scalars['DateTime'];
};


export type MutationSetLegacyDowntimeArgs = {
  deviceNumber: Scalars['ID'];
  from: Scalars['DateTime'];
  marketLocationId: Scalars['ID'];
  to: Scalars['DateTime'];
};


export type MutationSetSalesPartnerPermissionArgs = {
  granted: Scalars['Boolean'];
  permissionId: Scalars['ID'];
};


export type MutationSetSalesPartnersAsConfiguredArgs = {
  contractPartnerNumbers: ReadonlyArray<Scalars['Int']>;
};


export type MutationUpdateAccountArgs = {
  email: Scalars['String'];
  marketLocationIds?: InputMaybe<ReadonlyArray<Scalars['ID']>>;
  name: Scalars['String'];
  permissions: ReadonlyArray<AssignedPermissionInput>;
};


export type MutationUpdateAccountPermissionArgs = {
  email: Scalars['String'];
  permission: AssignedPermissionInput;
};


export type MutationUpdateDeviceArgs = {
  deviceId: Scalars['ID'];
  input: DeviceInput;
  maLoId: Scalars['ID'];
};


export type MutationUpdateForecastArgs = {
  device: Scalars['ID'];
  interval: IntervalInput;
  resolution: Resolution;
  slices: ReadonlyArray<ForecastSliceInput>;
};


export type MutationUpdateForecastWithTemplateArgs = {
  device: Scalars['ID'];
  hours: ReadonlyArray<Scalars['Int']>;
  interval: IntervalInput;
  resolution: Resolution;
  returnInterval?: InputMaybe<IntervalInput>;
  values: ReadonlyArray<FieldValueInput>;
  weekdays: ReadonlyArray<Weekday>;
};


export type MutationUpdateSalesPartnerPermissionArgs = {
  contractPartnerNumber: Scalars['Int'];
  granted: Scalars['Boolean'];
  permissionId: Scalars['ID'];
};

export type NullableMeasure = {
  readonly __typename?: 'NullableMeasure';
  readonly unit: Scalars['String'];
  readonly value?: Maybe<Scalars['Float']>;
};

export type NullableMeasureInput = {
  readonly unit: Scalars['String'];
  readonly value?: InputMaybe<Scalars['Float']>;
};

export enum OptimizationFeatures {
  PORTAL_REDIRECT = 'PORTAL_REDIRECT',
  SCHEDULE_DOWNLOAD = 'SCHEDULE_DOWNLOAD'
}

export type OptimizationFileList = {
  readonly __typename?: 'OptimizationFileList';
  readonly files: ReadonlyArray<Scalars['String']>;
  readonly modelNamesWithoutFiles: ReadonlyArray<Scalars['String']>;
};

export type OptimizationRun = {
  readonly __typename?: 'OptimizationRun';
  readonly status: Scalars['String'];
};

export type OptimizationStatus = {
  readonly __typename?: 'OptimizationStatus';
  readonly authorizedFeatures: ReadonlyArray<OptimizationFeatures>;
  readonly id: Scalars['ID'];
  readonly isAuthorized: Scalars['Boolean'];
  readonly optimizedContractIds: ReadonlyArray<Scalars['Int']>;
};

/** Provides information about the current page. */
export type PageInfo = {
  readonly __typename?: 'PageInfo';
  /** The cursor to the last element of the current page. */
  readonly endCursor?: Maybe<Scalars['String']>;
  /** Indicates whether more elements exist after the current page. */
  readonly hasNextPage: Scalars['Boolean'];
  /** Indicates whether more elements exist before the current page. */
  readonly hasPreviousPage: Scalars['Boolean'];
  /** The cursor to the first element of the current page. */
  readonly startCursor?: Maybe<Scalars['String']>;
};

export type Product = {
  readonly __typename?: 'Product';
  readonly id: Scalars['ID'];
  readonly marketingDeadline?: Maybe<MarketingDeadline>;
  readonly name: Scalars['String'];
};

export type ProductLimits = {
  readonly __typename?: 'ProductLimits';
  readonly contractLowerLimit: NullableMeasure;
  readonly contractUpperLimit: NullableMeasure;
  readonly doubleStrokeLowerLimit: Measure;
  readonly doubleStrokeUpperLimit: Measure;
  readonly flexBandLimit: NullableMeasure;
  readonly product: ProductType;
};

export type ProductLimitsPeriod = {
  readonly __typename?: 'ProductLimitsPeriod';
  readonly productLimits: ReadonlyArray<ProductLimits>;
  readonly validFrom: Scalars['DateTime'];
  readonly validTo?: Maybe<Scalars['DateTime']>;
};

export type ProductService = {
  readonly __typename?: 'ProductService';
  readonly begin: Scalars['String'];
  readonly end?: Maybe<Scalars['String']>;
  readonly type: ProductServiceType;
};

export enum ProductServiceType {
  COMMISSION = 'COMMISSION',
  DAY_AHEAD_OPTIMIZATION = 'DAY_AHEAD_OPTIMIZATION',
  INTRADAY_MARKETING = 'INTRADAY_MARKETING',
  INTRADAY_OPTIMIZATION = 'INTRADAY_OPTIMIZATION'
}

export enum ProductType {
  AFRR_NEG = 'AFRR_NEG',
  AFRR_POS = 'AFRR_POS',
  DM = 'DM',
  FCR_NEG = 'FCR_NEG',
  FCR_POS = 'FCR_POS',
  FLEXPLUS = 'FLEXPLUS',
  MFRR_NEG = 'MFRR_NEG',
  MFRR_POS = 'MFRR_POS'
}

export type Query = {
  readonly __typename?: 'Query';
  readonly OptimizationGroupData: Json;
  readonly accounts: ReadonlyArray<Account>;
  readonly annualOverview: AnnualOverview;
  readonly batteryDeviceAcceptedForecasts: DatapointCollection;
  readonly batteryForecast: ReadonlyArray<Forecast>;
  readonly deviceOptimizationStatus: DeviceOptimizationStatus;
  readonly deviceTimeSeries: ReadonlyArray<DeviceTimeSeries>;
  readonly feedIn: ReadonlyArray<FeedIn>;
  readonly forecast: ReadonlyArray<Forecast>;
  readonly getDefaultForecast: ReadonlyArray<DefaultForecast>;
  readonly getForecastLimits: ForecastPageLimitsResponse;
  readonly marketLocation: MarketLocation;
  readonly marketLocationTimeSeries: ReadonlyArray<MarketLocationTimeSeries>;
  readonly marketLocations: MarketLocationConnection;
  readonly optimizationFileList: OptimizationFileList;
  readonly optimizationStatus: OptimizationStatus;
  readonly permissions: ReadonlyArray<AssignedPermission>;
  readonly powerLevels: ReadonlyArray<NullableMeasure>;
  readonly productLimits: ReadonlyArray<ProductLimitsPeriod>;
  readonly revenueData: RevenueReport;
  readonly salesPartnerGroup?: Maybe<SalesPartnerGroup>;
  readonly salesPartners: ReadonlyArray<SalesPartner>;
  readonly spotPrices: SpotPriceForecast;
};


export type QueryOptimizationGroupDataArgs = {
  siteId: Scalars['String'];
};


export type QueryAnnualOverviewArgs = {
  marketLocationId: Scalars['ID'];
  year: Scalars['Int'];
};


export type QueryBatteryDeviceAcceptedForecastsArgs = {
  deviceNumbers: ReadonlyArray<Scalars['ID']>;
  interval: IntervalInput;
};


export type QueryBatteryForecastArgs = {
  devices: ReadonlyArray<Scalars['ID']>;
  interval: IntervalInput;
};


export type QueryDeviceOptimizationStatusArgs = {
  deviceId: Scalars['String'];
};


export type QueryDeviceTimeSeriesArgs = {
  deviceNumbers: ReadonlyArray<Scalars['ID']>;
  interval: IntervalInput;
};


export type QueryFeedInArgs = {
  interval: IntervalInput;
  marketLocations: ReadonlyArray<FeedInMarketLocation>;
};


export type QueryForecastArgs = {
  devices: ReadonlyArray<Scalars['ID']>;
  interval: IntervalInput;
  resolution: Resolution;
};


export type QueryGetDefaultForecastArgs = {
  deviceId: Scalars['ID'];
};


export type QueryGetForecastLimitsArgs = {
  device: ForecastPageDeviceInput;
  months: ReadonlyArray<Month>;
};


export type QueryMarketLocationArgs = {
  id: Scalars['ID'];
};


export type QueryMarketLocationTimeSeriesArgs = {
  interval: IntervalInput;
  marketLocationNumbers: ReadonlyArray<Scalars['ID']>;
  marketLocationTimeSeriesTypes: ReadonlyArray<MarketLocationTimeSeriesType>;
};


export type QueryMarketLocationsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type QueryOptimizationFileListArgs = {
  contractPartnerIds: ReadonlyArray<Scalars['String']>;
};


export type QueryPowerLevelsArgs = {
  deviceId: Scalars['String'];
};


export type QueryProductLimitsArgs = {
  deviceInternalId: Scalars['String'];
  from: Scalars['DateTime'];
  to: Scalars['DateTime'];
};


export type QueryRevenueDataArgs = {
  date: Scalars['DateTime'];
  marketLocationId: Scalars['ID'];
  scope: RevenueScope;
};


export type QuerySpotPricesArgs = {
  from: Scalars['DateTime'];
  resolution: Resolution;
  to: Scalars['DateTime'];
};

export enum Resolution {
  FIFTEEN_MINUTES = 'FIFTEEN_MINUTES',
  FOUR_HOURS = 'FOUR_HOURS',
  ONE_HOUR = 'ONE_HOUR'
}

export type RevenueItem = {
  readonly __typename?: 'RevenueItem';
  readonly amount?: Maybe<Scalars['Float']>;
  readonly key: Scalars['ID'];
  readonly price?: Maybe<Scalars['Float']>;
  readonly sum?: Maybe<Scalars['Float']>;
};

export type RevenueReport = {
  readonly __typename?: 'RevenueReport';
  readonly items: ReadonlyArray<RevenueItem>;
  readonly marketLocationId: Scalars['ID'];
};

export enum RevenueScope {
  MONTH = 'MONTH',
  QUARTER = 'QUARTER'
}

export type RevokeLegacyDowntimeResponse = {
  readonly __typename?: 'RevokeLegacyDowntimeResponse';
  readonly revokeLegacyDowntime: DatapointCollection;
};

export type SalesPartner = {
  readonly __typename?: 'SalesPartner';
  readonly assignedMarketLocations: ReadonlyArray<AssignedMarketLocation>;
  readonly contractPartnerNumber: Scalars['Int'];
  readonly id: Scalars['ID'];
  readonly isConfigured: Scalars['Boolean'];
  readonly name: Scalars['String'];
  readonly permissions: ReadonlyArray<AssignedPermission>;
};

export type SalesPartnerGroup = {
  readonly __typename?: 'SalesPartnerGroup';
  readonly id: Scalars['ID'];
  readonly isConfigured: Scalars['Boolean'];
  readonly name: Scalars['String'];
  readonly permissions: ReadonlyArray<AssignedPermission>;
};

export type SetLegacyDowntimeResponse = {
  readonly __typename?: 'SetLegacyDowntimeResponse';
  readonly setLegacyDowntime: DatapointCollection;
};

export type SparseMarketLocation = {
  readonly __typename?: 'SparseMarketLocation';
  readonly contractPartner: Scalars['String'];
  readonly externalName: Scalars['String'];
  readonly id: Scalars['ID'];
  readonly linkedMarketLocation?: Maybe<SparseMarketLocation>;
  readonly marketingEnd?: Maybe<Scalars['DateTime']>;
  readonly marketingStart?: Maybe<Scalars['DateTime']>;
  readonly name: Scalars['String'];
  readonly permissions: MarketLocationPermissions;
  readonly technologies: ReadonlyArray<MachineTechnology>;
  readonly type?: Maybe<MarketLocationType>;
};

/** Edge type for {@link SparseMarketLocation} elements. */
export type SparseMarketLocationEdge = {
  readonly __typename?: 'SparseMarketLocationEdge';
  /** The cursor pointing to the element within the {@link node} field. */
  readonly cursor: Scalars['String'];
  /** The current element. */
  readonly node: SparseMarketLocation;
};

export type SpotPriceForecast = {
  readonly __typename?: 'SpotPriceForecast';
  readonly dayAheadForecasts: ReadonlyArray<SpotPriceForecastSlice>;
  readonly intradayForecasts: ReadonlyArray<SpotPriceForecastSlice>;
  readonly lastUpdated?: Maybe<Scalars['DateTime']>;
  readonly latestHistoricalSpotPrice?: Maybe<Scalars['DateTime']>;
  readonly monthlyMarketValues: ReadonlyArray<MonthlyMarketValue>;
  readonly resolution: Resolution;
};

export type SpotPriceForecastSlice = {
  readonly __typename?: 'SpotPriceForecastSlice';
  readonly date: Scalars['DateTime'];
  readonly price: Scalars['Float'];
};

export type TimeSlice = {
  readonly __typename?: 'TimeSlice';
  readonly entities: ReadonlyArray<Entity>;
  readonly timestamp: Scalars['DateTime'];
};

export enum Weekday {
  FRIDAY = 'FRIDAY',
  MONDAY = 'MONDAY',
  SATURDAY = 'SATURDAY',
  SUNDAY = 'SUNDAY',
  THURSDAY = 'THURSDAY',
  TUESDAY = 'TUESDAY',
  WEDNESDAY = 'WEDNESDAY'
}

export type SidebarMarketLocationFieldsFragment = { readonly __typename?: 'MarketLocation', readonly id: string, readonly type?: MarketLocationType | null, readonly name: string, readonly externalName: string, readonly contractPartner: string, readonly technologies: ReadonlyArray<MachineTechnology>, readonly marketingStart?: Date | null, readonly marketingEnd?: Date | null, readonly permissions: { readonly __typename?: 'MarketLocationPermissions', readonly seeForecast: boolean, readonly editForecast: boolean, readonly seeRevenue: boolean } };

export type LinkedSidebarMarketLocationFieldsFragment = { readonly __typename?: 'MarketLocation', readonly id: string, readonly type?: MarketLocationType | null, readonly name: string, readonly externalName: string, readonly contractPartner: string, readonly technologies: ReadonlyArray<MachineTechnology>, readonly marketingStart?: Date | null, readonly marketingEnd?: Date | null, readonly linkedMarketLocation?: { readonly __typename?: 'MarketLocation', readonly id: string, readonly type?: MarketLocationType | null, readonly name: string, readonly externalName: string, readonly contractPartner: string, readonly technologies: ReadonlyArray<MachineTechnology>, readonly marketingStart?: Date | null, readonly marketingEnd?: Date | null, readonly permissions: { readonly __typename?: 'MarketLocationPermissions', readonly seeForecast: boolean, readonly editForecast: boolean, readonly seeRevenue: boolean } } | null, readonly permissions: { readonly __typename?: 'MarketLocationPermissions', readonly seeForecast: boolean, readonly editForecast: boolean, readonly seeRevenue: boolean } };

export type SidebarMarketLocationsQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  before?: InputMaybe<Scalars['String']>;
  after?: InputMaybe<Scalars['String']>;
}>;


export type SidebarMarketLocationsQuery = { readonly __typename?: 'Query', readonly marketLocations: { readonly __typename?: 'MarketLocationConnection', readonly totalCount: number, readonly pageInfo: { readonly __typename?: 'PageInfo', readonly hasPreviousPage: boolean, readonly hasNextPage: boolean, readonly startCursor?: string | null, readonly endCursor?: string | null }, readonly edges: ReadonlyArray<{ readonly __typename?: 'MarketLocationEdge', readonly cursor: string, readonly node: { readonly __typename?: 'MarketLocation', readonly id: string, readonly type?: MarketLocationType | null, readonly name: string, readonly externalName: string, readonly contractPartner: string, readonly technologies: ReadonlyArray<MachineTechnology>, readonly marketingStart?: Date | null, readonly marketingEnd?: Date | null, readonly linkedMarketLocation?: { readonly __typename?: 'MarketLocation', readonly id: string, readonly type?: MarketLocationType | null, readonly name: string, readonly externalName: string, readonly contractPartner: string, readonly technologies: ReadonlyArray<MachineTechnology>, readonly marketingStart?: Date | null, readonly marketingEnd?: Date | null, readonly permissions: { readonly __typename?: 'MarketLocationPermissions', readonly seeForecast: boolean, readonly editForecast: boolean, readonly seeRevenue: boolean } } | null, readonly permissions: { readonly __typename?: 'MarketLocationPermissions', readonly seeForecast: boolean, readonly editForecast: boolean, readonly seeRevenue: boolean } } }> } };

export type DefaultForecastQueryVariables = Exact<{
  deviceId: Scalars['ID'];
}>;


export type DefaultForecastQuery = { readonly __typename?: 'Query', readonly getDefaultForecast: ReadonlyArray<{ readonly __typename?: 'DefaultForecast', readonly id: string, readonly month: Month, readonly auxiliaryConsumption: { readonly __typename?: 'NullableMeasure', readonly value?: number | null, readonly unit: string }, readonly minimum: { readonly __typename?: 'NullableMeasure', readonly value?: number | null, readonly unit: string }, readonly maximum: { readonly __typename?: 'NullableMeasure', readonly value?: number | null, readonly unit: string }, readonly forecasts: ReadonlyArray<{ readonly __typename?: 'DefaultForecastSlice', readonly value: { readonly __typename?: 'NullableMeasure', readonly value?: number | null, readonly unit: string }, readonly interval: { readonly __typename?: 'Interval', readonly start: Date, readonly end: Date } }> }> };

export type ChangeDefaultForecastMutationVariables = Exact<{
  deviceId: Scalars['ID'];
  forecast: ReadonlyArray<DefaultForecastInput> | DefaultForecastInput;
}>;


export type ChangeDefaultForecastMutation = { readonly __typename?: 'Mutation', readonly changeDefaultForecast: ReadonlyArray<{ readonly __typename?: 'DefaultForecast', readonly id: string, readonly month: Month, readonly auxiliaryConsumption: { readonly __typename?: 'NullableMeasure', readonly value?: number | null, readonly unit: string }, readonly minimum: { readonly __typename?: 'NullableMeasure', readonly value?: number | null, readonly unit: string }, readonly maximum: { readonly __typename?: 'NullableMeasure', readonly value?: number | null, readonly unit: string }, readonly forecasts: ReadonlyArray<{ readonly __typename?: 'DefaultForecastSlice', readonly value: { readonly __typename?: 'NullableMeasure', readonly value?: number | null, readonly unit: string }, readonly interval: { readonly __typename?: 'Interval', readonly start: Date, readonly end: Date } }> }> };

export type SetTemplatedForecastDataMutationVariables = Exact<{
  device: Scalars['ID'];
  interval: IntervalInput;
  resolution: Resolution;
  weekdays: ReadonlyArray<Weekday> | Weekday;
  hours: ReadonlyArray<Scalars['Int']> | Scalars['Int'];
  values: ReadonlyArray<FieldValueInput> | FieldValueInput;
  returnInterval?: InputMaybe<IntervalInput>;
}>;


export type SetTemplatedForecastDataMutation = { readonly __typename?: 'Mutation', readonly updateForecastWithTemplate: ReadonlyArray<{ readonly __typename?: 'ForecastSlice', readonly id: string, readonly date: Date, readonly hasDowntime: boolean, readonly fields: ReadonlyArray<{ readonly __typename?: 'FieldValue', readonly type: InputFieldType, readonly watt?: number | null }> }> };

export type SetForecastDataMutationVariables = Exact<{
  device: Scalars['ID'];
  interval: IntervalInput;
  resolution: Resolution;
  slices: ReadonlyArray<ForecastSliceInput> | ForecastSliceInput;
}>;


export type SetForecastDataMutation = { readonly __typename?: 'Mutation', readonly updateForecast: ReadonlyArray<{ readonly __typename?: 'ForecastSlice', readonly id: string, readonly date: Date, readonly hasDowntime: boolean, readonly fields: ReadonlyArray<{ readonly __typename?: 'FieldValue', readonly type: InputFieldType, readonly watt?: number | null }> }> };

export type AccountFragmentFragment = { readonly __typename?: 'Account', readonly id: string, readonly name: string, readonly email: string, readonly permissions: ReadonlyArray<{ readonly __typename?: 'AssignedPermission', readonly id: string, readonly permissionId: string, readonly granted: boolean }>, readonly marketLocations?: ReadonlyArray<{ readonly __typename?: 'AssignedMarketLocation', readonly id: string, readonly name: string, readonly externalName?: string | null }> | null };

export type GetAccountsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAccountsQuery = { readonly __typename?: 'Query', readonly accounts: ReadonlyArray<{ readonly __typename?: 'Account', readonly id: string, readonly name: string, readonly email: string, readonly permissions: ReadonlyArray<{ readonly __typename?: 'AssignedPermission', readonly id: string, readonly permissionId: string, readonly granted: boolean }>, readonly marketLocations?: ReadonlyArray<{ readonly __typename?: 'AssignedMarketLocation', readonly id: string, readonly name: string, readonly externalName?: string | null }> | null }> };

export type CreateAccountMutationVariables = Exact<{
  email: Scalars['String'];
  name: Scalars['String'];
  permissions: ReadonlyArray<AssignedPermissionInput> | AssignedPermissionInput;
  marketLocationIds?: InputMaybe<ReadonlyArray<Scalars['ID']> | Scalars['ID']>;
}>;


export type CreateAccountMutation = { readonly __typename?: 'Mutation', readonly createAccount: { readonly __typename?: 'Account', readonly id: string, readonly name: string, readonly email: string, readonly permissions: ReadonlyArray<{ readonly __typename?: 'AssignedPermission', readonly id: string, readonly permissionId: string, readonly granted: boolean }>, readonly marketLocations?: ReadonlyArray<{ readonly __typename?: 'AssignedMarketLocation', readonly id: string, readonly name: string, readonly externalName?: string | null }> | null } };

export type DeleteAccountMutationVariables = Exact<{
  email: Scalars['String'];
}>;


export type DeleteAccountMutation = { readonly __typename?: 'Mutation', readonly deleteAccount: { readonly __typename?: 'DeleteAccountResponse', readonly deleted: boolean } };

export type UpdateAccountPermissionMutationVariables = Exact<{
  email: Scalars['String'];
  permission: AssignedPermissionInput;
}>;


export type UpdateAccountPermissionMutation = { readonly __typename?: 'Mutation', readonly updateAccountPermission: { readonly __typename?: 'AssignedPermission', readonly id: string, readonly permissionId: string, readonly granted: boolean } };

export type UpdateAccountMutationVariables = Exact<{
  email: Scalars['String'];
  name: Scalars['String'];
  permissions: ReadonlyArray<AssignedPermissionInput> | AssignedPermissionInput;
  marketLocationIds?: InputMaybe<ReadonlyArray<Scalars['ID']> | Scalars['ID']>;
}>;


export type UpdateAccountMutation = { readonly __typename?: 'Mutation', readonly updateAccount: { readonly __typename?: 'Account', readonly id: string, readonly name: string, readonly email: string, readonly permissions: ReadonlyArray<{ readonly __typename?: 'AssignedPermission', readonly id: string, readonly permissionId: string, readonly granted: boolean }>, readonly marketLocations?: ReadonlyArray<{ readonly __typename?: 'AssignedMarketLocation', readonly id: string, readonly name: string, readonly externalName?: string | null }> | null } };

export type AnnualOverviewQueryVariables = Exact<{
  marketLocationId: Scalars['ID'];
  year: Scalars['Int'];
}>;


export type AnnualOverviewQuery = { readonly __typename?: 'Query', readonly annualOverview: { readonly __typename?: 'AnnualOverview', readonly marketLocationId: string, readonly latestFeedDate?: Date | null, readonly totalMeasuredFeedsAtLeast85PercentOfCapacity: number, readonly totalForecastedSum: { readonly __typename?: 'NullableMeasure', readonly value?: number | null, readonly unit: string }, readonly totalForecastedMean: { readonly __typename?: 'NullableMeasure', readonly value?: number | null, readonly unit: string }, readonly totalMeasurementSum: { readonly __typename?: 'NullableMeasure', readonly value?: number | null, readonly unit: string }, readonly totalMeasurementMean: { readonly __typename?: 'NullableMeasure', readonly value?: number | null, readonly unit: string }, readonly totalConsumptionMeasurementSum: { readonly __typename?: 'NullableMeasure', readonly value?: number | null, readonly unit: string }, readonly totalConsumptionMeasurementMean: { readonly __typename?: 'NullableMeasure', readonly value?: number | null, readonly unit: string }, readonly monthlyOverview: ReadonlyArray<{ readonly __typename?: 'MonthOverview', readonly month: Month, readonly totalMeasuredFeedsAtLeast85PercentOfCapacity: number, readonly totalForecasted: { readonly __typename?: 'NullableMeasure', readonly value?: number | null, readonly unit: string }, readonly meanForecasted: { readonly __typename?: 'NullableMeasure', readonly value?: number | null, readonly unit: string }, readonly totalMeasurement: { readonly __typename?: 'NullableMeasure', readonly value?: number | null, readonly unit: string }, readonly meanMeasurement: { readonly __typename?: 'NullableMeasure', readonly value?: number | null, readonly unit: string }, readonly totalConsumptionMeasurement: { readonly __typename?: 'NullableMeasure', readonly value?: number | null, readonly unit: string }, readonly meanConsumptionMeasurement: { readonly __typename?: 'NullableMeasure', readonly value?: number | null, readonly unit: string }, readonly specificAdditionalRevenue: { readonly __typename?: 'NullableMeasure', readonly value?: number | null, readonly unit: string } }> } };

export type BatteryDeviceAcceptedForecastsQueryVariables = Exact<{
  deviceNumbers: ReadonlyArray<Scalars['ID']> | Scalars['ID'];
  interval: IntervalInput;
}>;


export type BatteryDeviceAcceptedForecastsQuery = { readonly __typename?: 'Query', readonly batteryDeviceAcceptedForecasts: { readonly __typename?: 'DatapointCollection', readonly type: DatapointCollectionType, readonly resolution: Resolution, readonly entityType: EntityType, readonly timeSlices: ReadonlyArray<{ readonly __typename?: 'TimeSlice', readonly timestamp: Date, readonly entities: ReadonlyArray<{ readonly __typename?: 'Entity', readonly number: number, readonly datapoints: ReadonlyArray<{ readonly __typename?: 'Datapoint', readonly type: DatapointType, readonly value: number }> }> }> } };

export type UpdateDeviceMutationVariables = Exact<{
  maLoId: Scalars['ID'];
  deviceId: Scalars['ID'];
  input: DeviceInput;
}>;


export type UpdateDeviceMutation = { readonly __typename?: 'Mutation', readonly updateDevice: { readonly __typename?: 'Device', readonly externalName?: string | null, readonly id: string, readonly internalId: string, readonly name: string, readonly products: ReadonlyArray<{ readonly __typename?: 'Product', readonly id: string, readonly name: string, readonly marketingDeadline?: { readonly __typename?: 'MarketingDeadline', readonly deadlineForEarliestForecast: string, readonly daysBeforeDelivery: number, readonly minutesBeforeIntradayDelivery?: number | null } | null }>, readonly deadlines: ReadonlyArray<{ readonly __typename?: 'Deadline', readonly type: InputFieldType, readonly deadline?: { readonly __typename?: 'MarketingDeadline', readonly deadlineForEarliestForecast: string, readonly daysBeforeDelivery: number, readonly minutesBeforeIntradayDelivery?: number | null } | null }> } };

export type GetDeviceOptimizationStatusQueryVariables = Exact<{
  deviceId: Scalars['String'];
}>;


export type GetDeviceOptimizationStatusQuery = { readonly __typename?: 'Query', readonly deviceOptimizationStatus: { readonly __typename?: 'DeviceOptimizationStatus', readonly isActive: boolean, readonly nextRun?: Date | null, readonly interval?: string | null } };

export type DeviceTimeSeriesQueryVariables = Exact<{
  deviceNumbers: ReadonlyArray<Scalars['ID']> | Scalars['ID'];
  interval: IntervalInput;
}>;


export type DeviceTimeSeriesQuery = { readonly __typename?: 'Query', readonly deviceTimeSeries: ReadonlyArray<{ readonly __typename?: 'DeviceTimeSeries', readonly id: string, readonly deviceNumber: string, readonly datapoints: ReadonlyArray<{ readonly __typename?: 'DeviceDatapoint', readonly date: Date, readonly energyCapabilityPos?: number | null, readonly energyCapabilityNeg?: number | null, readonly actualPower?: number | null }> }> };

export type FeedInQueryVariables = Exact<{
  marketLocations: ReadonlyArray<FeedInMarketLocation> | FeedInMarketLocation;
  interval: IntervalInput;
}>;


export type FeedInQuery = { readonly __typename?: 'Query', readonly feedIn: ReadonlyArray<{ readonly __typename?: 'FeedIn', readonly id: string, readonly marketLocationId: string, readonly interval: { readonly __typename?: 'Interval', readonly start: Date, readonly end: Date }, readonly values: ReadonlyArray<{ readonly __typename?: 'FeedInValue', readonly date: Date, readonly forecastedValue?: number | null, readonly measuredValue?: number | null, readonly msconsCode?: string | null }> }> };

export type ForecastDataQueryVariables = Exact<{
  devices: ReadonlyArray<Scalars['ID']> | Scalars['ID'];
  interval: IntervalInput;
  resolution: Resolution;
}>;


export type ForecastDataQuery = { readonly __typename?: 'Query', readonly forecast: ReadonlyArray<{ readonly __typename?: 'Forecast', readonly id: string, readonly deviceId: string, readonly resolution: Resolution, readonly interval: { readonly __typename?: 'Interval', readonly start: Date, readonly end: Date }, readonly slices: ReadonlyArray<{ readonly __typename?: 'ForecastSlice', readonly id: string, readonly date: Date, readonly hasDowntime: boolean, readonly fields: ReadonlyArray<{ readonly __typename?: 'FieldValue', readonly type: InputFieldType, readonly watt?: number | null, readonly value: { readonly __typename?: 'NullableMeasure', readonly value?: number | null, readonly unit: string } }> }> }> };

export type BatteryForecastDataQueryVariables = Exact<{
  devices: ReadonlyArray<Scalars['ID']> | Scalars['ID'];
  interval: IntervalInput;
}>;


export type BatteryForecastDataQuery = { readonly __typename?: 'Query', readonly batteryForecast: ReadonlyArray<{ readonly __typename?: 'Forecast', readonly id: string, readonly deviceId: string, readonly resolution: Resolution, readonly interval: { readonly __typename?: 'Interval', readonly start: Date, readonly end: Date }, readonly slices: ReadonlyArray<{ readonly __typename?: 'ForecastSlice', readonly id: string, readonly date: Date, readonly hasDowntime: boolean, readonly fields: ReadonlyArray<{ readonly __typename?: 'FieldValue', readonly type: InputFieldType, readonly watt?: number | null, readonly value: { readonly __typename?: 'NullableMeasure', readonly value?: number | null, readonly unit: string } }> }> }> };

export type DefaultForecastLimitsQueryVariables = Exact<{
  deviceId: Scalars['ID'];
}>;


export type DefaultForecastLimitsQuery = { readonly __typename?: 'Query', readonly getDefaultForecast: ReadonlyArray<{ readonly __typename?: 'DefaultForecast', readonly id: string, readonly month: Month, readonly minimum: { readonly __typename?: 'NullableMeasure', readonly value?: number | null, readonly unit: string }, readonly maximum: { readonly __typename?: 'NullableMeasure', readonly value?: number | null, readonly unit: string }, readonly auxiliaryConsumption: { readonly __typename?: 'NullableMeasure', readonly value?: number | null, readonly unit: string } }> };

export type InputFieldLimitsQueryVariables = Exact<{
  device: ForecastPageDeviceInput;
  months: ReadonlyArray<Month> | Month;
}>;


export type InputFieldLimitsQuery = { readonly __typename?: 'Query', readonly getForecastLimits: { readonly __typename?: 'ForecastPageLimitsResponse', readonly installedPower: { readonly __typename?: 'NullableMeasure', readonly value?: number | null, readonly unit: string }, readonly fields: ReadonlyArray<{ readonly __typename?: 'ForecastPageFieldLimit', readonly type: InputFieldType, readonly isDisabled: boolean, readonly lowerLimit: { readonly __typename?: 'Limit', readonly limitSpecification: LimitSpecification, readonly limit: { readonly __typename?: 'Measure', readonly value: number, readonly unit: string } }, readonly upperLimit: { readonly __typename?: 'Limit', readonly limitSpecification: LimitSpecification, readonly limit: { readonly __typename?: 'Measure', readonly value: number, readonly unit: string } }, readonly negativeBand?: { readonly __typename?: 'NullableMeasure', readonly value?: number | null, readonly unit: string } | null, readonly positiveBand?: { readonly __typename?: 'NullableMeasure', readonly value?: number | null, readonly unit: string } | null }> } };

export type MarketLocationTimeSeriesQueryVariables = Exact<{
  marketLocationNumbers: ReadonlyArray<Scalars['ID']> | Scalars['ID'];
  marketLocationTimeSeriesTypes: ReadonlyArray<MarketLocationTimeSeriesType> | MarketLocationTimeSeriesType;
  interval: IntervalInput;
}>;


export type MarketLocationTimeSeriesQuery = { readonly __typename?: 'Query', readonly marketLocationTimeSeries: ReadonlyArray<{ readonly __typename?: 'MarketLocationTimeSeries', readonly marketLocationNumber: string, readonly marketLocationTimeSeriesType: MarketLocationTimeSeriesType, readonly datapoints: ReadonlyArray<{ readonly __typename?: 'MarketLocationDatapoint', readonly timestamp: Date, readonly value?: number | null }> }> };

export type MarketLocationQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type MarketLocationQuery = { readonly __typename?: 'Query', readonly marketLocation: { readonly __typename?: 'MarketLocation', readonly id: string, readonly type?: MarketLocationType | null, readonly number: string, readonly marketLocationId: string, readonly measureLocationId: string, readonly name: string, readonly externalName: string, readonly technologies: ReadonlyArray<MachineTechnology>, readonly contractPartner: string, readonly distributionNetworkOperator?: string | null, readonly transmissionSystemOperator?: string | null, readonly marketingStart?: Date | null, readonly marketingEnd?: Date | null, readonly linkedMarketLocation?: { readonly __typename?: 'MarketLocation', readonly id: string, readonly type?: MarketLocationType | null, readonly number: string, readonly marketLocationId: string, readonly measureLocationId: string, readonly name: string, readonly externalName: string, readonly technologies: ReadonlyArray<MachineTechnology>, readonly contractPartner: string, readonly distributionNetworkOperator?: string | null, readonly transmissionSystemOperator?: string | null, readonly marketingStart?: Date | null, readonly marketingEnd?: Date | null, readonly products: ReadonlyArray<{ readonly __typename?: 'Product', readonly id: string, readonly name: string, readonly marketingDeadline?: { readonly __typename?: 'MarketingDeadline', readonly deadlineForEarliestForecast: string, readonly daysBeforeDelivery: number, readonly minutesBeforeIntradayDelivery?: number | null } | null }>, readonly machines: ReadonlyArray<{ readonly __typename?: 'Machine', readonly id: string, readonly name: string, readonly machineTechnology: MachineTechnology, readonly devices: ReadonlyArray<{ readonly __typename?: 'Device', readonly externalName?: string | null, readonly id: string, readonly internalId: string, readonly name: string, readonly tradingGroupId?: string | null, readonly products: ReadonlyArray<{ readonly __typename?: 'Product', readonly id: string, readonly name: string, readonly marketingDeadline?: { readonly __typename?: 'MarketingDeadline', readonly deadlineForEarliestForecast: string, readonly daysBeforeDelivery: number, readonly minutesBeforeIntradayDelivery?: number | null } | null }>, readonly deadlines: ReadonlyArray<{ readonly __typename?: 'Deadline', readonly type: InputFieldType, readonly deadline?: { readonly __typename?: 'MarketingDeadline', readonly deadlineForEarliestForecast: string, readonly daysBeforeDelivery: number, readonly minutesBeforeIntradayDelivery?: number | null } | null }> }>, readonly installedPower: { readonly __typename?: 'NullableMeasure', readonly value?: number | null, readonly unit: string }, readonly address: { readonly __typename?: 'Address', readonly organization?: string | null, readonly street?: string | null, readonly houseNumber?: string | null, readonly postCode?: string | null, readonly city?: string | null, readonly country?: string | null, readonly countryName?: string | null } }>, readonly machinesTotalOutput: { readonly __typename?: 'NullableMeasure', readonly value?: number | null, readonly unit: string }, readonly permissions: { readonly __typename?: 'MarketLocationPermissions', readonly seeForecast: boolean, readonly editForecast: boolean, readonly seeRevenue: boolean }, readonly billingTypes: ReadonlyArray<{ readonly __typename?: 'BillingType', readonly year: number, readonly month: Month, readonly isOpenBook: boolean }>, readonly productServices: ReadonlyArray<{ readonly __typename?: 'ProductService', readonly type: ProductServiceType, readonly begin: string, readonly end?: string | null }>, readonly forecastProperties?: ReadonlyArray<{ readonly __typename?: 'ForecastProperty', readonly resolution: Resolution, readonly editableMarkets: ReadonlyArray<EditableMarket>, readonly target: ForecastTarget, readonly validFrom: string, readonly validTo?: string | null }> | null } | null, readonly products: ReadonlyArray<{ readonly __typename?: 'Product', readonly id: string, readonly name: string, readonly marketingDeadline?: { readonly __typename?: 'MarketingDeadline', readonly deadlineForEarliestForecast: string, readonly daysBeforeDelivery: number, readonly minutesBeforeIntradayDelivery?: number | null } | null }>, readonly machines: ReadonlyArray<{ readonly __typename?: 'Machine', readonly id: string, readonly name: string, readonly machineTechnology: MachineTechnology, readonly devices: ReadonlyArray<{ readonly __typename?: 'Device', readonly externalName?: string | null, readonly id: string, readonly internalId: string, readonly name: string, readonly tradingGroupId?: string | null, readonly products: ReadonlyArray<{ readonly __typename?: 'Product', readonly id: string, readonly name: string, readonly marketingDeadline?: { readonly __typename?: 'MarketingDeadline', readonly deadlineForEarliestForecast: string, readonly daysBeforeDelivery: number, readonly minutesBeforeIntradayDelivery?: number | null } | null }>, readonly deadlines: ReadonlyArray<{ readonly __typename?: 'Deadline', readonly type: InputFieldType, readonly deadline?: { readonly __typename?: 'MarketingDeadline', readonly deadlineForEarliestForecast: string, readonly daysBeforeDelivery: number, readonly minutesBeforeIntradayDelivery?: number | null } | null }> }>, readonly installedPower: { readonly __typename?: 'NullableMeasure', readonly value?: number | null, readonly unit: string }, readonly address: { readonly __typename?: 'Address', readonly organization?: string | null, readonly street?: string | null, readonly houseNumber?: string | null, readonly postCode?: string | null, readonly city?: string | null, readonly country?: string | null, readonly countryName?: string | null } }>, readonly machinesTotalOutput: { readonly __typename?: 'NullableMeasure', readonly value?: number | null, readonly unit: string }, readonly permissions: { readonly __typename?: 'MarketLocationPermissions', readonly seeForecast: boolean, readonly editForecast: boolean, readonly seeRevenue: boolean }, readonly billingTypes: ReadonlyArray<{ readonly __typename?: 'BillingType', readonly year: number, readonly month: Month, readonly isOpenBook: boolean }>, readonly productServices: ReadonlyArray<{ readonly __typename?: 'ProductService', readonly type: ProductServiceType, readonly begin: string, readonly end?: string | null }>, readonly forecastProperties?: ReadonlyArray<{ readonly __typename?: 'ForecastProperty', readonly resolution: Resolution, readonly editableMarkets: ReadonlyArray<EditableMarket>, readonly target: ForecastTarget, readonly validFrom: string, readonly validTo?: string | null }> | null } };

export type MarketLocationFieldsFragment = { readonly __typename?: 'MarketLocation', readonly id: string, readonly type?: MarketLocationType | null, readonly number: string, readonly marketLocationId: string, readonly measureLocationId: string, readonly name: string, readonly externalName: string, readonly technologies: ReadonlyArray<MachineTechnology>, readonly contractPartner: string, readonly distributionNetworkOperator?: string | null, readonly transmissionSystemOperator?: string | null, readonly marketingStart?: Date | null, readonly marketingEnd?: Date | null, readonly products: ReadonlyArray<{ readonly __typename?: 'Product', readonly id: string, readonly name: string, readonly marketingDeadline?: { readonly __typename?: 'MarketingDeadline', readonly deadlineForEarliestForecast: string, readonly daysBeforeDelivery: number, readonly minutesBeforeIntradayDelivery?: number | null } | null }>, readonly machines: ReadonlyArray<{ readonly __typename?: 'Machine', readonly id: string, readonly name: string, readonly machineTechnology: MachineTechnology, readonly devices: ReadonlyArray<{ readonly __typename?: 'Device', readonly externalName?: string | null, readonly id: string, readonly internalId: string, readonly name: string, readonly tradingGroupId?: string | null, readonly products: ReadonlyArray<{ readonly __typename?: 'Product', readonly id: string, readonly name: string, readonly marketingDeadline?: { readonly __typename?: 'MarketingDeadline', readonly deadlineForEarliestForecast: string, readonly daysBeforeDelivery: number, readonly minutesBeforeIntradayDelivery?: number | null } | null }>, readonly deadlines: ReadonlyArray<{ readonly __typename?: 'Deadline', readonly type: InputFieldType, readonly deadline?: { readonly __typename?: 'MarketingDeadline', readonly deadlineForEarliestForecast: string, readonly daysBeforeDelivery: number, readonly minutesBeforeIntradayDelivery?: number | null } | null }> }>, readonly installedPower: { readonly __typename?: 'NullableMeasure', readonly value?: number | null, readonly unit: string }, readonly address: { readonly __typename?: 'Address', readonly organization?: string | null, readonly street?: string | null, readonly houseNumber?: string | null, readonly postCode?: string | null, readonly city?: string | null, readonly country?: string | null, readonly countryName?: string | null } }>, readonly machinesTotalOutput: { readonly __typename?: 'NullableMeasure', readonly value?: number | null, readonly unit: string }, readonly permissions: { readonly __typename?: 'MarketLocationPermissions', readonly seeForecast: boolean, readonly editForecast: boolean, readonly seeRevenue: boolean }, readonly billingTypes: ReadonlyArray<{ readonly __typename?: 'BillingType', readonly year: number, readonly month: Month, readonly isOpenBook: boolean }>, readonly productServices: ReadonlyArray<{ readonly __typename?: 'ProductService', readonly type: ProductServiceType, readonly begin: string, readonly end?: string | null }>, readonly forecastProperties?: ReadonlyArray<{ readonly __typename?: 'ForecastProperty', readonly resolution: Resolution, readonly editableMarkets: ReadonlyArray<EditableMarket>, readonly target: ForecastTarget, readonly validFrom: string, readonly validTo?: string | null }> | null };

export type GetOptimizationStatusQueryVariables = Exact<{ [key: string]: never; }>;


export type GetOptimizationStatusQuery = { readonly __typename?: 'Query', readonly optimizationStatus: { readonly __typename?: 'OptimizationStatus', readonly id: string, readonly isAuthorized: boolean, readonly authorizedFeatures: ReadonlyArray<OptimizationFeatures>, readonly optimizedContractIds: ReadonlyArray<number> } };

export type OptimizationGroupDataQueryVariables = Exact<{
  siteId: Scalars['String'];
}>;


export type OptimizationGroupDataQuery = { readonly __typename?: 'Query', readonly OptimizationGroupData: { readonly __typename?: 'Json', readonly json?: string | null } };

export type OptimizationGroupDataUpdateMutationVariables = Exact<{
  siteId: Scalars['String'];
  updatedParameters: Scalars['String'];
}>;


export type OptimizationGroupDataUpdateMutation = { readonly __typename?: 'Mutation', readonly OptimizationGroupDataUpdate: { readonly __typename?: 'Json', readonly json?: string | null } };

export type OptimizationRunnerMutationVariables = Exact<{
  siteId: Scalars['String'];
}>;


export type OptimizationRunnerMutation = { readonly __typename?: 'Mutation', readonly OptimizationRunner: { readonly __typename?: 'OptimizationRun', readonly status: string } };

export type GetOptimizationFileListQueryVariables = Exact<{
  contractPartnerIds: ReadonlyArray<Scalars['String']> | Scalars['String'];
}>;


export type GetOptimizationFileListQuery = { readonly __typename?: 'Query', readonly optimizationFileList: { readonly __typename?: 'OptimizationFileList', readonly files: ReadonlyArray<string>, readonly modelNamesWithoutFiles: ReadonlyArray<string> } };

export type GetPermissionsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetPermissionsQuery = { readonly __typename?: 'Query', readonly permissions: ReadonlyArray<{ readonly __typename?: 'AssignedPermission', readonly id: string, readonly permissionId: string, readonly granted: boolean }> };

export type PowerLevelsQueryVariables = Exact<{
  deviceId: Scalars['String'];
}>;


export type PowerLevelsQuery = { readonly __typename?: 'Query', readonly powerLevels: ReadonlyArray<{ readonly __typename?: 'NullableMeasure', readonly value?: number | null, readonly unit: string }> };

export type ProductLimitsQueryVariables = Exact<{
  deviceInternalId: Scalars['String'];
  from: Scalars['DateTime'];
  to: Scalars['DateTime'];
}>;


export type ProductLimitsQuery = { readonly __typename?: 'Query', readonly productLimits: ReadonlyArray<{ readonly __typename?: 'ProductLimitsPeriod', readonly validFrom: Date, readonly validTo?: Date | null, readonly productLimits: ReadonlyArray<{ readonly __typename?: 'ProductLimits', readonly product: ProductType, readonly doubleStrokeLowerLimit: { readonly __typename?: 'Measure', readonly value: number, readonly unit: string }, readonly doubleStrokeUpperLimit: { readonly __typename?: 'Measure', readonly value: number, readonly unit: string }, readonly contractLowerLimit: { readonly __typename?: 'NullableMeasure', readonly value?: number | null, readonly unit: string }, readonly contractUpperLimit: { readonly __typename?: 'NullableMeasure', readonly value?: number | null, readonly unit: string }, readonly flexBandLimit: { readonly __typename?: 'NullableMeasure', readonly value?: number | null, readonly unit: string } }> }> };

export type RevenueDataQueryVariables = Exact<{
  scope: RevenueScope;
  marketLocationId: Scalars['ID'];
  date: Scalars['DateTime'];
}>;


export type RevenueDataQuery = { readonly __typename?: 'Query', readonly revenueData: { readonly __typename?: 'RevenueReport', readonly marketLocationId: string, readonly items: ReadonlyArray<{ readonly __typename?: 'RevenueItem', readonly key: string, readonly amount?: number | null, readonly price?: number | null, readonly sum?: number | null }> } };

export type SetSalesPartnerConfiguredMutationVariables = Exact<{ [key: string]: never; }>;


export type SetSalesPartnerConfiguredMutation = { readonly __typename?: 'Mutation', readonly setSalesPartnerConfigured: { readonly __typename?: 'SalesPartnerGroup', readonly id: string, readonly isConfigured: boolean } };

export type SetSalesPartnersAsConfiguredMutationVariables = Exact<{
  contractPartnerNumbers: ReadonlyArray<Scalars['Int']> | Scalars['Int'];
}>;


export type SetSalesPartnersAsConfiguredMutation = { readonly __typename?: 'Mutation', readonly setSalesPartnersAsConfigured: ReadonlyArray<{ readonly __typename?: 'SalesPartner', readonly id: string, readonly name: string, readonly contractPartnerNumber: number, readonly isConfigured: boolean, readonly permissions: ReadonlyArray<{ readonly __typename?: 'AssignedPermission', readonly id: string, readonly permissionId: string, readonly granted: boolean }>, readonly assignedMarketLocations: ReadonlyArray<{ readonly __typename?: 'AssignedMarketLocation', readonly id: string, readonly name: string, readonly externalName?: string | null }> }> };

export type SetSalesPartnerPermissionMutationVariables = Exact<{
  permissionId: Scalars['ID'];
  granted: Scalars['Boolean'];
}>;


export type SetSalesPartnerPermissionMutation = { readonly __typename?: 'Mutation', readonly setSalesPartnerPermission: { readonly __typename?: 'AssignedPermission', readonly id: string, readonly permissionId: string, readonly granted: boolean } };

export type UpdateSalesPartnerPermissionMutationVariables = Exact<{
  contractPartnerNumber: Scalars['Int'];
  permissionId: Scalars['ID'];
  granted: Scalars['Boolean'];
}>;


export type UpdateSalesPartnerPermissionMutation = { readonly __typename?: 'Mutation', readonly updateSalesPartnerPermission: { readonly __typename?: 'AssignedPermission', readonly id: string, readonly permissionId: string, readonly granted: boolean } };

export type SalesPartnerQueryVariables = Exact<{ [key: string]: never; }>;


export type SalesPartnerQuery = { readonly __typename?: 'Query', readonly salesPartnerGroup?: { readonly __typename?: 'SalesPartnerGroup', readonly id: string, readonly name: string, readonly isConfigured: boolean, readonly permissions: ReadonlyArray<{ readonly __typename?: 'AssignedPermission', readonly id: string, readonly permissionId: string, readonly granted: boolean }> } | null };

export type SalesPartnersQueryVariables = Exact<{ [key: string]: never; }>;


export type SalesPartnersQuery = { readonly __typename?: 'Query', readonly salesPartners: ReadonlyArray<{ readonly __typename?: 'SalesPartner', readonly id: string, readonly name: string, readonly contractPartnerNumber: number, readonly isConfigured: boolean, readonly permissions: ReadonlyArray<{ readonly __typename?: 'AssignedPermission', readonly id: string, readonly permissionId: string, readonly granted: boolean }>, readonly assignedMarketLocations: ReadonlyArray<{ readonly __typename?: 'AssignedMarketLocation', readonly id: string, readonly name: string, readonly externalName?: string | null }> }> };

export type SpotPricesQueryVariables = Exact<{
  resolution: Resolution;
  from: Scalars['DateTime'];
  to: Scalars['DateTime'];
}>;


export type SpotPricesQuery = { readonly __typename?: 'Query', readonly spotPrices: { readonly __typename?: 'SpotPriceForecast', readonly lastUpdated?: Date | null, readonly latestHistoricalSpotPrice?: Date | null, readonly resolution: Resolution, readonly dayAheadForecasts: ReadonlyArray<{ readonly __typename?: 'SpotPriceForecastSlice', readonly date: Date, readonly price: number }>, readonly intradayForecasts: ReadonlyArray<{ readonly __typename?: 'SpotPriceForecastSlice', readonly date: Date, readonly price: number }>, readonly monthlyMarketValues: ReadonlyArray<{ readonly __typename?: 'MonthlyMarketValue', readonly year: number, readonly month: Month, readonly min: number, readonly max: number, readonly mean: number, readonly isProvisional: boolean }> } };

export type AddressFieldsFragment = { readonly __typename?: 'Address', readonly organization?: string | null, readonly street?: string | null, readonly houseNumber?: string | null, readonly postCode?: string | null, readonly city?: string | null, readonly country?: string | null, readonly countryName?: string | null };

export type IntervalFieldsFragment = { readonly __typename?: 'Interval', readonly start: Date, readonly end: Date };

export type MeasureFieldsFragment = { readonly __typename?: 'Measure', readonly value: number, readonly unit: string };

export type NullableMeasureFieldsFragment = { readonly __typename?: 'NullableMeasure', readonly value?: number | null, readonly unit: string };

export type ProductFieldsFragment = { readonly __typename?: 'Product', readonly id: string, readonly name: string, readonly marketingDeadline?: { readonly __typename?: 'MarketingDeadline', readonly deadlineForEarliestForecast: string, readonly daysBeforeDelivery: number, readonly minutesBeforeIntradayDelivery?: number | null } | null };

export type DeviceFieldsFragment = { readonly __typename?: 'Device', readonly externalName?: string | null, readonly id: string, readonly internalId: string, readonly name: string, readonly products: ReadonlyArray<{ readonly __typename?: 'Product', readonly id: string, readonly name: string, readonly marketingDeadline?: { readonly __typename?: 'MarketingDeadline', readonly deadlineForEarliestForecast: string, readonly daysBeforeDelivery: number, readonly minutesBeforeIntradayDelivery?: number | null } | null }>, readonly deadlines: ReadonlyArray<{ readonly __typename?: 'Deadline', readonly type: InputFieldType, readonly deadline?: { readonly __typename?: 'MarketingDeadline', readonly deadlineForEarliestForecast: string, readonly daysBeforeDelivery: number, readonly minutesBeforeIntradayDelivery?: number | null } | null }> };

export type SetLegacyDowntimeMutationVariables = Exact<{
  marketLocationId: Scalars['ID'];
  deviceNumber: Scalars['ID'];
  from: Scalars['DateTime'];
  to: Scalars['DateTime'];
}>;


export type SetLegacyDowntimeMutation = { readonly __typename?: 'Mutation', readonly setLegacyDowntime: { readonly __typename?: 'SetLegacyDowntimeResponse', readonly setLegacyDowntime: { readonly __typename?: 'DatapointCollection', readonly entityType: EntityType, readonly resolution: Resolution, readonly type: DatapointCollectionType, readonly timeSlices: ReadonlyArray<{ readonly __typename?: 'TimeSlice', readonly timestamp: Date, readonly entities: ReadonlyArray<{ readonly __typename?: 'Entity', readonly number: number, readonly datapoints: ReadonlyArray<{ readonly __typename?: 'Datapoint', readonly type: DatapointType, readonly value: number }> }> }> } } };

export type SetDowntimeMutationVariables = Exact<{
  deviceNumber: Scalars['ID'];
  from: Scalars['DateTime'];
  to: Scalars['DateTime'];
}>;


export type SetDowntimeMutation = { readonly __typename?: 'Mutation', readonly setDowntime: boolean };

export type RevokeLegacyDowntimeMutationVariables = Exact<{
  deviceNumber: Scalars['String'];
  from: Scalars['DateTime'];
  to: Scalars['DateTime'];
}>;


export type RevokeLegacyDowntimeMutation = { readonly __typename?: 'Mutation', readonly revokeLegacyDowntime: { readonly __typename?: 'RevokeLegacyDowntimeResponse', readonly revokeLegacyDowntime: { readonly __typename?: 'DatapointCollection', readonly entityType: EntityType, readonly resolution: Resolution, readonly type: DatapointCollectionType, readonly timeSlices: ReadonlyArray<{ readonly __typename?: 'TimeSlice', readonly timestamp: Date, readonly entities: ReadonlyArray<{ readonly __typename?: 'Entity', readonly number: number, readonly datapoints: ReadonlyArray<{ readonly __typename?: 'Datapoint', readonly type: DatapointType, readonly value: number }> }> }> } } };

export type RevokeDowntimeMutationVariables = Exact<{
  deviceNumber: Scalars['ID'];
  from: Scalars['DateTime'];
  to: Scalars['DateTime'];
}>;


export type RevokeDowntimeMutation = { readonly __typename?: 'Mutation', readonly revokeDowntime: boolean };
